"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@linaria/react");
var _core = require("@linaria/core");
"avce8jl";
const AvailableCardStyle = /*#__PURE__*/(0, _react.styled)("div")({
  name: "AvailableCardStyle",
  class: "aioi3su"
});
var _default = exports.default = AvailableCardStyle;